import defaultLarge from '../../images/illustrations/stars/starscape-header-large.svg'
import defaultMedium from '../../images/illustrations/stars/starscape-header-medium.svg'
import defaultSmall from '../../images/illustrations/stars/starscape-header-small.svg'

const defaultHeroStarscapes = {
  xSmall: { url: defaultSmall, position: `center` },
  small: { url: defaultMedium, position: `center bottom` },
  medium: { url: defaultLarge, position: `right` },
}

export default defaultHeroStarscapes
